// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import { reset } from 'redux-form';
import type { ThunkAction } from '../../types';

export function updatePassword(values: any): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/account/password/change';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        oldPassword: values.currentPassword,
        newPassword: values.newPassword
      }
    };
    return makeAPICall(endpoint, options).then(
      () => {
        // clear password form fields
        dispatch(reset('passwordForm'));
      },
      error =>
        dispatch(APIError(error, "Error updating logged In User's password"))
    );
  };
}

export function forgotPassword(email: string): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/account/password/forgot';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: { productId: config.productId },
      data: {
        email
      }
    };
    return makeAPICall(endpoint, options).then(
      response => response,
      error => dispatch(APIError(error, 'Error sending Reset Password email'))
    );
  };
}

export function resetPassword(newPassword: string, token: string): ThunkAction {
  return function(dispatch) {
    const endpoint = '/account/password/reset';
    const options = {
      method: 'POST',
      headers: { token },
      params: { productId: config.productId },
      data: { newPassword }
    };
    return makeAPICall(endpoint, options).then(
      response => response,
      error => dispatch(APIError(error, 'Error resetting password'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/authentication/passwordCreators.js